var map = {
	"./featured-blogs.de-CH.json": 1310,
	"./featured-blogs.de-DE.json": 1311,
	"./featured-blogs.en-CA.json": 1312,
	"./featured-blogs.en-GB.json": 1313,
	"./featured-blogs.en-IN.json": 1314,
	"./featured-blogs.en-ME.json": 1315,
	"./featured-blogs.en-US.json": 1316,
	"./featured-blogs.es-EM.json": 1317,
	"./featured-blogs.es-ES.json": 1318,
	"./featured-blogs.fr-BE.json": 1319,
	"./featured-blogs.fr-CA.json": 1320,
	"./featured-blogs.fr-CH.json": 1321,
	"./featured-blogs.nl-BE.json": 1322,
	"./featured-blogs.nl-NL.json": 1323,
	"./featured-blogs.pl-PL.json": 1324,
	"./featured-blogs.pt-BR.json": 1325
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1309;